import {createApp} from 'vue'
import App from './App.vue'
import router from './router';

import {IonicVue} from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */
/* @import '@ionic-old/vue/css/palettes/dark.always.css'; */
/* @import '@ionic-old/vue/css/palettes/dark.class.css'; */
//import '@ionic-old/vue/css/palettes/dark.system.css';
/* Theme variables */
import './theme/variables.css';
import AuthPlugin from "@/plugins/auth/AuthPlugin";
import * as Sentry from "@sentry/capacitor";
import * as SentryVue from "@sentry/vue";

const htmlTitle = `ARABTEST ${__APP_VERSION_SHORT__}`;
document.title = htmlTitle;


const app = createApp(App)
    .use(AuthPlugin)
    .use(IonicVue)
    .use(router)
;

const env = import.meta.env;
const sentryDNS = env.VITE_SENTRY_DNS;

if (env.MODE === 'production' && sentryDNS) {
    console.debug("Sentry enabled");
    Sentry.init({
            app,
            dsn: sentryDNS,
            environment: env.MODE,
            integrations: [
                // Registers and configures the Tracing integration,
                // which automatically instruments your application to monitor its
                // performance, including custom Angular routing instrumentation
                Sentry.browserTracingIntegration({router}),
                // Registers the Replay integration,
                // which automatically captures Session Replays
                Sentry.replayIntegration(),
            ],

            // Tracing
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        },
        SentryVue.init
    );
}


router.isReady().then(() => {
    app.mount('#app');
});
